import css from './index.module.scss';
import OtherList from '@/components/ProductCommon/OtherList';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';

export function EOther() {
    const { useLang, gloproductlist, useRouter } = useGlobal();
    const { t } = useLang('xboost');
    const { locale } = useRouter();

    const arr = ['mx'].includes(locale)
        ? ['product_ps_delta_delta_2', 'product_ps_delta_delta_2_max', 'product_ps_river_river_256']
        : ['au', 'za', 'sa'].includes(locale)
        ? ['product_ps_delta_delta_pro', 'product_ps_delta_delta_max', 'product_ps_river_river_pro_720']
        : ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_river_river_256'];

    const otherProducts = getDetaileMoreProducts(gloproductlist, arr);

    if (locale === 'ph') return null; // 菲律宾不展示
    return (
        <div className={`E_other ${css.E_other}`}>
            <div className="text-wrapper">
                <p className="title">{t('section_5_title')}</p>
                <p className="desc">{t('section_5_desc')}</p>
            </div>
            <OtherList theme="black" data={otherProducts} />
            <div className="note">
                <p className="noteTitle">{t('section_5_note_title')}</p>
                <p className="noteContent">{t('section_5_note_content')}</p>
            </div>
        </div>
    );
}
